import { Beacon } from '@/plugins/beacon';
import { i18n } from '@/plugins/i18n';
import { vuetify } from '@/plugins/vuetify';
import { StorageService } from '@/services/storage.service';
import moment from 'moment';
import { Validator } from 'vee-validate';

export function localize(locale) {
  StorageService.setLocale(locale);

  // Localize plugins
  i18n.locale = locale;
  vuetify.framework.lang.current = String(locale).startsWith('fr') ? 'fr' : 'en';
  Beacon.setLocale(locale);
  moment.locale(locale);
  Validator.localize(locale);
}
